import _assign from "object-assign";
import { typography, createTypography as styleCreateTypography } from '@jpmuitk/style';

var _styleCreateTypograph = styleCreateTypography(),
    getFace = _styleCreateTypograph.getFace;

export var createTypography = function createTypography() {
  return _assign({
    fontWeight: 'normal'
  }, getFace(), {
    // px
    fontSize: 12
  }, typography);
};